var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-stepper',{attrs:{"steps":_vm.steps,"actions":_vm.actions,"current-step":_vm.currentStep,"is-next-step-disabled":_vm.isNextStepDisabled},on:{"navigate":_vm.navigate,"confirm":_vm.send}})}
var staticRenderFns = []

export { render, staticRenderFns }